export enum NamespaceState {
  Unknown = 0,
  Active = 1,
  Suspended = 4,
}